import React, { useEffect, useState } from 'react';
import { Modal } from 'udesk-ui';
import Udesk from 'Udesk';
import './style.scss';
import { useUdeskContext } from 'src/util/hook';
import { LoadingOutlined } from '@ant-design/icons';
import UdeskLocales from 'UdeskLocales';

const ASRStatusModal = ({ visible, onClose }) => {
    const [asrData, setAsrData] = useState({});
    const context = useUdeskContext();

    useEffect(() => {
        if (visible) {
            const url = Udesk.business.apiPath.concatApiPath(
                '/asrTrainingStatus/latestInfo',
                context.props.sdkOptions
            );
            Udesk.ajax.get(url).then((resp) => {
                setAsrData(resp.data || {});
            });
        }
    }, [context.props.sdkOptions, visible]);

    return (
        <Modal width={460} visible={visible} onCancel={onClose} title={/* ASR训练状态 */UdeskLocales['current'].components.asrStatusModal.index.aSRTrainingStatus} footer={null}>
            <div className="asr-status-content">
                {asrData === null ? (
                    <div className="loading-wrapper">
                        <LoadingOutlined style={{ fontSize: 24 }} spin />
                    </div>
                ) : (
                    <>
                        <div className="asr-tag">{/* 中文ASR */}{UdeskLocales['current'].components.asrStatusModal.index.chineseASR}</div>
                        <ul className="asr-status-list">
                            <li>{/* ASR模型更新时间(通用): */}{UdeskLocales['current'].components.asrStatusModal.index.aSRModelUpdateTimegeneric}{asrData.asrModelUpdateTime || '-'}</li>
                            <li>{/* ASR模型更新时间(专属): */}{UdeskLocales['current'].components.asrStatusModal.index.aSRModelUpdateTimeexclusive}{' '}
                                {asrData.asrModelProprietaryUpdateTime || '-'}
                            </li>
                            <li>{/* 已训练纠错数量: */}{UdeskLocales['current'].components.asrStatusModal.index.numberOfErrorCorrectionsTrained}{asrData.trainedCorrectionCount || 0}</li>
                            <li>{/* 已训练纠错时长: */}{UdeskLocales['current'].components.asrStatusModal.index.trainedErrorCorrectionDuration}{asrData.trainedCorrectionDuration || 0}{/* 分钟 */}{UdeskLocales['current'].components.asrStatusModal.index.minutes}</li>
                            <li>{/* 未训练纠错数量: */}{UdeskLocales['current'].components.asrStatusModal.index.numberOfUntrainedErrors}{asrData.untrainedCorrectionCount || 0}</li>
                            <li>{/* 未训练纠错时长: */}{UdeskLocales['current'].components.asrStatusModal.index.untrainedErrorCorrectionDuration}{asrData.untrainedCorrectionDuration || 0}{/* 分钟 */}{UdeskLocales['current'].components.asrStatusModal.index.minutes}</li>
                        </ul>
                    </>
                )}
            </div>
        </Modal>
    );
};

export default ASRStatusModal;
